<template>
  <b-modal
    ref="modal"
    class="modal-confirm"
    content-class="rounded-10 position-relative"
    hide-footer
    hide-header
    size="sm"
    :visible="visible"
    no-close-on-backdrop
    no-close-on-esc
    :centered="true"
  >
    <div
      class="main d-block text-center text-16 my-4 d-flex align-items-center justify-content-center flex-wrap"
      style="min-height: 60px; white-space: pre-line"
    >
      <template v-if="$slots.main">
        <slot name="main"></slot>
      </template>

      <template v-else>
        <img
          v-if="img"
          :src="img"
          style="width: 140px; height: 140px"
          class="mb-3"
        />
        <span
          class="message"
          :class="variant ? `text-${variant}` : messageClass"
          >{{ message }}</span
        >
        <span v-show="subMessage" class="sub" :class="subClass">{{
          subMessage
        }}</span>
        <ol v-if="list" class="list text-left">
          <li v-for="(item, index) in list" :key="index">{{ item }}</li>
        </ol>
      </template>
    </div>
    <div class="text-center mb-2 buttons">
      <b-button
        v-show="cancelText"
        class="cancel"
        variant="secondary"
        size="md mr-3"
        @click="handelCancel"
        >{{ cancelText }}</b-button
      >
      <b-button
        size="md"
        variant="primary"
        class="confirm"
        :class="confirmClass"
        @click="handelConfirm"
      >
        <i v-if="confirmIcon" :class="confirmIcon"></i>
        {{ confirmText }}
      </b-button>
    </div>
    <span
      v-if="hasClose"
      class="btn-close text-primary cursor-pointer position-absolute text-32 icon-X"
      @click.prevent="handelCancel"
    >
    </span>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      promise: null,
      message: '',
      messageClass: '',
      subMessage: '',
      subClass: '',
      confirmText: '確定',
      confirmClass: '',
      cancelText: '',
      confirmIcon: '',
      hasClose: false,
      variant: null,
      img: null,
      list: null,
    };
  },
  methods: {
    init() {
      this.visible = true;
      return new Promise((resolve, reject) => {
        this.promise = {resolve, reject};
      });
    },
    handelCancel() {
      this.promise.resolve(false);
      this.destroyVm();
    },
    handelConfirm() {
      this.promise.resolve(true);
      this.destroyVm();
    },
    destroyVm() {
      this.visible = false;
      setTimeout(() => {
        this.$destroy(true);
        this.$el && this.$el.parentNode.removeChild(this.$el);
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep() .modal-content {
  width: 300px;
  margin: 0 auto;
  .modal-body {
    padding: $spacing-l;
  }
  .main {
    color: $font-normal;
  }
  .sub {
    color: $accent;
  }
  .list {
    padding-inline-start: 1em;
    margin-bottom: 0;
  }
  .btn-close {
    top: 8px;
    right: 8px;
  }
  .text-primary.message {
    font-size: 18px;
    font-weight: 700;
  }
  .buttons {
    [class^='icon-'],
    [class*=' icon-'] {
      &::before {
        font-size: 20px;
        vertical-align: inherit;
        margin-right: 2px;
      }
    }
  }
  i {
    position: relative;
    top: 3px;
  }
}
</style>
